import { writable } from 'svelte/store';
export const currentRoute = writable(window.location.hash || '#manage-user');
if (typeof window !== 'undefined') {
    window.addEventListener('hashchange', () => {
        currentRoute.set(window.location.hash);
    });
}
